<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useNotificationStore } from '../../../stores/notification'
import NotificationToast from './NotificationToast.vue'

const store = useNotificationStore()
const { notifications } = storeToRefs(store)
</script>

<template>
  <div id="desktop-notification-bubble" class="fixed bottom-4 right-4 z-50 space-y-2">
    <NotificationToast
      v-for="notification in notifications"
      :key="notification.id"
      :notification="notification"
      @close="store.removeNotification(notification.id)"
    />
  </div>
</template>